module.exports = __webpack_public_path__ + "static/farm-equipment-03a845e31e6babc8709b0cdda652b7e6.jpg";